import { useCallback, useState } from 'react';
import { RequestInfo } from './types';

const useXhrRequest = () => {
  const [requestData, setRequestData] = useState<RequestInfo | null>(null);

  const send = useCallback(async (url: string, headers: Record<string, string>) => {
    let responseStartTime = performance.now();
    setRequestData({
      method: 'POST',
      url: url,
      status: 'pending',
      startTime: responseStartTime,
    });

    const xhr = new XMLHttpRequest();

    xhr.onload = () => {
      const responseEndTime = performance.now();
      const responseTime = responseEndTime - responseStartTime;

      const headers: Record<string, string> = {};
      const headerString = xhr.getAllResponseHeaders();
      headerString.split('\r\n').forEach((line) => {
        const parts = line.split(': ');
        if (parts.length === 2) {
          headers[parts[0]] = parts[1];
        }
      });

      const responseSize = new Blob([xhr.responseText]).size;

      setRequestData({
        method: 'POST',
        url: url,
        status: 'completed',
        statusCode: xhr.status,
        statusText: xhr.statusText,
        headers,
        responseTime,
        responseSize,
        responseBody: xhr.responseText,
        startTime: responseStartTime,
      });
    };

    xhr.onerror = () => {
      setRequestData({
        method: 'POST',
        url: url,
        status: 'error',
        error: 'Network request failed',
        startTime: responseStartTime,
      });
    };

    xhr.open('POST', url, true);

    Object.entries(headers).forEach(([key, value]) => {
      console.log('setting header for xhr request', { [key]: value });
      xhr.setRequestHeader(key, value);
    });

    responseStartTime = performance.now();
    xhr.send(JSON.stringify({}));
  }, []);

  return [requestData, send] as const;
};

export default useXhrRequest;
